import { useLocale, useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { useMemo, useRef } from 'react';
import type { Translations } from '@aviv-unified-frontend/runtime/i18n';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';

export const NAME_SPACE = 'app_esfu_estimationFunnel';

/**
 * Hook to load the translations for the current brand and locale.
 */
export const useLoadTranslations = (namespace: typeof NAME_SPACE, portal: Portal) => {
    const { locale } = useLocale();
    const { addTranslations } = useTranslation(namespace);
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    const removeTranslations = useRef<() => undefined | void>();

    removeTranslations.current = useMemo(() => {
        removeTranslations.current?.();
        const fileName = portal === Portal.ImmoWeb && locale === 'fr' ? 'fr_BE' : locale;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const translations: Translations = require(`../../../../../../libs/translations/src/lib/${portal.toLowerCase()}/${fileName}.json`);

        return addTranslations({
            locale,
            translations,
        });
    }, [addTranslations, locale]);
};
